<script>
export default {
  props: ['langActive', 'language'],
  methods: {
    showLangBox() {
      this.$emit('show-lang-box');
    },
  },
};
</script>

<template>
  <li class="lang-button">
    <button class="no-style" @click="showLangBox">
      <transition name="slide-fade" mode="out-in">
        <i aria-hidden="true" class="material-icons">language</i>
      </transition>
      <span>Language</span>
    </button>
  </li>
</template>
